import { VIEW } from 'types/deck'

import PhatDropdown from 'components/formElements/PhatDropdown'
import ViewExtras from 'components/deckPage/filtersAndControls/ViewExtras'

import { useActions, useAppSelector } from 'app-redux/hooks'
import { setDeckStateAction } from 'app-redux/deck/actions'
import { useModerator } from 'hooks/adFree'

import { setLocalView } from 'services/accountSettings.service'

import styles from './deckViewAsDropdown.module.scss'

type Props = {
  noExtras?: boolean
  onViewAsChange?: () => void
}

const DeckViewAsDropdown = ({ noExtras, onViewAsChange }: Props) => {
  const view = useAppSelector(state => state.deck.view)
  const isMobile = useAppSelector(state => state.active.isMobile)

  const isModerator = useModerator()

  const [setDeckState] = useActions(setDeckStateAction)

  const handleViewChange = (_e: any, { value }: any) => {
    setDeckState({ view: value })
    setLocalView(value)

    if (onViewAsChange) onViewAsChange()
  }

  const viewOptions = [
    { text: 'Stacks', value: VIEW.CARD },
    { text: 'List', value: VIEW.LIST, hidden: !isMobile && !isModerator },
    { text: 'Text', value: VIEW.TEXT },
    // { text: 'Brewer', value: VIEW.BREWING },
    { text: 'Grid', value: VIEW.GRID },
    // { text: 'Scroll', value: VIEW.SCROLL }, // Commenting out so people stop choosing it, we can remove VIEW.SCROLL later
    { text: 'Table', value: VIEW.SPREADSHEET },
  ]

  return (
    <PhatDropdown
      fixedMenu
      matchMenuWidthToParent
      header="View as"
      icon="eye"
      value={view}
      triggerWrapperClassName={styles.dropdown}
      options={viewOptions.map(opt => ({
        label: opt.text,
        id: `${opt.value}`,
        onClick: () => handleViewChange(null, { value: opt.value }),
        hidden: opt.hidden,
      }))}
      extraOptionsElement={noExtras ? null : <ViewExtras />}
    />
  )
}

export default DeckViewAsDropdown
